/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

export default isUndefined;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/isUndefined.js
// module id = ./node_modules/lodash-es/isUndefined.js
// module chunks = 1